import i18n from '../i18n';

import countries from 'i18n-iso-countries';
import en from 'i18n-iso-countries/langs/en.json';
import de from 'i18n-iso-countries/langs/de.json';
countries.registerLocale(en);
countries.registerLocale(de);

const countryNameByAlpha2Code = countries.getNames(i18n.locale, { select: 'official' });
const countriesArray = Object.entries(countryNameByAlpha2Code);

export default countriesArray;
